module.exports = __webpack_public_path__ + "media/images/overlay-df326adb86e161284a97fbe86a302155.png";